module.exports = __webpack_public_path__ + "static/media/grifovano-pletivo.5540d359.png";